
export default function Process() {
  const steps = [
    {
      number: '01',
      title: 'Request Quote',
      description: 'Tell us what you need cleaned and your service area. Photos are helpful but optional.'
    },
    {
      number: '02',
      title: 'Confirm & Schedule',
      description: 'Fast reply with pricing and flexible scheduling options that work for you.'
    },
    {
      number: '03',
      title: 'Prep & Protect',
      description: 'We pre-treat tough stains and protect surrounding surfaces before cleaning.'
    },
    {
      number: '04',
      title: 'Deep Clean + Final Check',
      description: 'Thorough cleaning with attention to detail, plus a quick walkthrough with you.'
    }
  ];

  return (
    <section id="process" className="py-24 bg-gradient-to-br from-blue-900 via-blue-800 to-blue-900 relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute inset-0" style={{
          backgroundImage: 'radial-gradient(circle at 2px 2px, white 1px, transparent 0)',
          backgroundSize: '40px 40px'
        }}></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl sm:text-5xl font-extrabold text-white mb-4">
            Our Process
          </h2>
          <div className="w-16 h-1 bg-gradient-to-r from-cyan-400 to-cyan-500 mx-auto mb-6"></div>
          <p className="text-lg text-blue-200 max-w-2xl mx-auto">
            Simple, transparent, and designed for your convenience
          </p>
        </div>

        {/* Timeline - Desktop */}
        <div className="hidden lg:block">
          <div className="relative">
            {/* Connecting Line */}
            <div className="absolute top-20 left-0 right-0 h-0.5 bg-gradient-to-r from-cyan-400 via-cyan-500 to-cyan-400" style={{ top: '80px' }}></div>

            <div className="grid grid-cols-4 gap-8">
              {steps.map((step, index) => (
                <div key={index} className="relative">
                  {/* Number Badge */}
                  <div className="w-20 h-20 bg-gradient-to-br from-cyan-400 to-cyan-500 rounded-full flex items-center justify-center mx-auto mb-6 shadow-xl relative z-10">
                    <span className="text-2xl font-extrabold text-white">{step.number}</span>
                  </div>

                  {/* Arrow */}
                  {index < steps.length - 1 && (
                    <div className="absolute top-10 right-0 transform translate-x-1/2">
                      <i className="ri-arrow-right-line text-cyan-400 text-2xl"></i>
                    </div>
                  )}

                  {/* Content */}
                  <div className="text-center">
                    <h3 className="text-xl font-bold text-white mb-3">
                      {step.title}
                    </h3>
                    <p className="text-sm text-blue-200 leading-relaxed">
                      {step.description}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Timeline - Mobile */}
        <div className="lg:hidden space-y-8">
          {steps.map((step, index) => (
            <div key={index} className="relative pl-20">
              {/* Vertical Line */}
              {index < steps.length - 1 && (
                <div className="absolute left-10 top-20 bottom-0 w-0.5 bg-gradient-to-b from-cyan-400 to-cyan-500 transform -translate-x-1/2"></div>
              )}

              {/* Number Badge */}
              <div className="absolute left-0 top-0 w-20 h-20 bg-gradient-to-br from-cyan-400 to-cyan-500 rounded-full flex items-center justify-center shadow-xl">
                <span className="text-2xl font-extrabold text-white">{step.number}</span>
              </div>

              {/* Content */}
              <div>
                <h3 className="text-xl font-bold text-white mb-2">
                  {step.title}
                </h3>
                <p className="text-sm text-blue-200 leading-relaxed">
                  {step.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
